// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners } from "~/lib/signals";
import { _ } from "~/i18n";
import { store } from "./state/store";

Mapy.ListPoi = class {
	constructor(poisData, options) {
		this._poisData = poisData;
		this._pois = [];
		this._dom = {
			container: node("div",{className: "trips"}),
			list: node("ul", {className:"trip-large"})
		};

		this._options = options;

		this._build();

		this._sc = [];
		this._sc.push(addListener(this, "detail-activated", "_updateVisibility"));
		this._sc.push(addListener(this, "detail-deactivated", "_updateVisibility"));
	}

	destroy() {
		while (this._pois.length) {
			this._pois.shift().destroy();
		}

		if (this._sc.length) {
			removeListeners(this._sc);
		}
	}

	getContainer() {
		return this._dom.container;
	}

	getLayer() {
		return this._options.layer;
	}

	getOptions() {
		return this._options;
	}

	_build() {
		for(var i = 0; i < this._poisData.length; i++) {
			var poi = new Mapy.ListPoi.Item(this._poisData[i], this);
			this._dom.list.appendChild(poi.getContainer());
			this._pois.push(poi);
		}

		if (this._pois.length) {
			if (!("title" in this._options) || ("title" in this._options && this._options.title != "")) {
				this._dom.container.appendChild(node("h4",{innerHTML: this._options.title || _("circuit.pois")}));
			}
			this._dom.container.appendChild(this._dom.list);
		}
	}

	_updateVisibility() {
		/* aktualizuje se viditelnost markeru v zavislosti na detailu */
		const { data } = store.getState().detail;

		if (this._options.layer) {
			if (data) {
				if (!data.source || !data.id) {
					return;
				}

				for(var i = 0; i < this._pois.length; i++) {
					var pData = this._pois[i].getData();

					if((pData.id == data.id) && (pData.source == data.source)) {
						this._pois[i].getMarker().setStyle("visibility", "hidden");
					} else {
						this._pois[i].getMarker().setStyle("visibility", "");
					}
				}
			} else {
				for(var i = 0; i < this._pois.length; i++) {
					this._pois[i].getMarker().setStyle("visibility", "");
				}
			}
		}
	}
};
